import { render } from "./ColorLegend.vue?vue&type=template&id=d8ddbc74&scoped=true"
import script from "./ColorLegend.vue?vue&type=script&lang=js"
export * from "./ColorLegend.vue?vue&type=script&lang=js"

import "./ColorLegend.vue?vue&type=style&index=0&id=d8ddbc74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d8ddbc74"

export default script